import { render, staticRenderFns } from "./SolicitorDashboard.vue?vue&type=template&id=1be172d4&scoped=true&"
import script from "./SolicitorDashboard.vue?vue&type=script&lang=js&"
export * from "./SolicitorDashboard.vue?vue&type=script&lang=js&"
import style0 from "./SolicitorDashboard.vue?vue&type=style&index=0&id=1be172d4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be172d4",
  null
  
)

export default component.exports